import styled from 'styled-components'
import { Radio } from 'antd'
import { ANTD_COLORS ,COLORS} from '../../theme'

export const StyledRadioGroup = styled(Radio.Group)`
  display: inline-flex;
  background:${COLORS.WHITE};
  border-radius: 8px;
  border: 1px solid ${COLORS.BLUE_T_69};
  width: 80%;

  .ant-radio-wrapper {
    margin: 0;
    padding: 9px 9px;
    border-radius: 7px;
    transition: all 0.3s ease;
    font-size: 14px;
    color: #6B7280;
    white-space: nowrap;
    width: 100%;
    align-items: center;
    justify-content: center;
    display: flex;;

    &:hover {
      color: #111827;
    }

    &.ant-radio-wrapper-checked {
      background: ${ANTD_COLORS.PRIMARY.replace(';', '')};
      color: white;
      font-weight: 500;
      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);

      .ant-radio {
        display: none;
      }
    }

    .ant-radio {
      display: none;
    }
  }
`
